import React, { useState } from "react";
import WeeklyAppointmentReportTab from "./WeeklyAppointmentReportTab";
import AttendanceReportTab from "./AttendanceReportTab";
import AppointmentSecondaryTabs from "./AppointmentSecondaryTabs";

const REPORT_SUB_TABS = [
  { id: "weekly", label: "Haftalık Rapor" },
  { id: "attendance", label: "Yoklama Raporu" },
] as const;

export default function AppointmentReportsTab() {
  const [activeSubTab, setActiveSubTab] = useState<"weekly" | "attendance">("weekly");

  return (
    <div className="relative mr-0 flex h-full min-h-0 w-full flex-col bg-gray-50 sm:mr-1 sm:rounded-lg sm:shadow-sm">
      <div className="flex-shrink-0 px-3 pt-4 sm:px-6 sm:pt-6">
        <AppointmentSecondaryTabs
          eyebrow="Raporlar"
          tabs={[...REPORT_SUB_TABS]}
          activeId={activeSubTab}
          onChange={(id) => setActiveSubTab(id as "weekly" | "attendance")}
        />
      </div>
      <div className="flex min-h-0 flex-1 flex-col overflow-auto px-3 pb-4 sm:px-6 sm:pb-6">
        {activeSubTab === "weekly" && <WeeklyAppointmentReportTab />}
        {activeSubTab === "attendance" && <AttendanceReportTab />}
      </div>
    </div>
  );
}
